import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../../../layout/service/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { MessageModule } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AddFormQuizDetails } from './add-form-quiz-details';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { ImageModule } from 'primeng/image';
import { PdfViewerModule } from 'ng2-pdf-viewer';


@Component({
    selector: 'app-form-quiz-cases',
    standalone: true,
    imports: [
        CommonModule,
        InputTextModule,
        SelectModule,
        ButtonModule,
        FormsModule,
        MessageModule,
        DialogModule,
        ToastModule,
        ConfirmDialogModule,
        AddFormQuizDetails,
        TableModule,
        AccordionModule,
        BadgeModule,
        ImageModule,
        PdfViewerModule
    ],
    providers: [ConfirmationService,MessageService],
    template: `
        <p-toast />
        <p-confirmdialog />
        <p-dialog header="Add Case" [(visible)]="showDialogCase" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw' }" position="top" [draggable]="false" [resizable]="false">
            <input type="text" [(ngModel)]="newCaseName" placeholder="Enter Case Name" pInputText class="mb-2 w-full" />
            <p-button type="button" [raised]="true" variant="text" label="Add Case" icon="pi pi-plus" class="w-full" (click)="addCase()" [disabled]="isLoading"></p-button>
        </p-dialog>
        <p-dialog header="Edit Case" [(visible)]="showDialogEdit" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw' }" position="top" [draggable]="false" [resizable]="false">
            <input type="text" [(ngModel)]="editedCaseName" placeholder="Enter New Case Name" pInputText class="mb-2 w-full" />
            <p-button type="button" label="Save Changes" icon="pi pi-check" class="w-full" (click)="submitEditCase()" [disabled]="isLoading"></p-button>
        </p-dialog>
        <p-dialog header="Show Image" [(visible)]="showDetailImage" [modal]="true" position="center" [draggable]="false" [resizable]="false">
                <ng-container *ngIf="showDetailImages.length > 0; else singleImage">
                    <div class="flex flex-wrap gap-4">
                        <div *ngFor="let img of showDetailImages" class="text-center">
                            <h3 class="w-full mb-2 text-sm font-semibold">{{ img.name }}</h3>
                            <p-image [src]="img.src" alt="{{ img.name }}" [preview]="true" width="250" />
                        </div>
                    </div>
                </ng-container>
                <ng-template #singleImage>
                    <p-image [src]="detailImage" alt="Image" [preview]="true" width="250" />
                </ng-template>
        </p-dialog>
        <p-dialog header="Explanation" [(visible)]="showDetailExplanation" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw' }" position="center" [draggable]="false" [resizable]="false">
            <pdf-viewer
                [src]="detailExplanation"
                [render-text]="true"
                [original-size]="false"
                style="width: 400px; height: 500px"
            ></pdf-viewer>
        </p-dialog>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-12 gap-4 md:gap-6 lg:gap-8">
            <!-- Kolom Kiri -->
            <div class="border shadow-md rounded p-4 col-span-6">
                <h3 class="text-lg font-semibold mb-4">{{ form.name }}</h3>

                <!-- IF NO CASE FOUND -->
                <div *ngIf="!hasCases">
                    <p-message severity="warn">
                        <p class="font-bold">No case available. <span class="font-normal text-grey-400">Please add a case before proceeding.</span></p>
                    </p-message>
                    <p-button severity="primary" label="Add Case" icon="pi pi-plus" [raised]="true" variant="outlined" styleClass="mt-5 w-full" (click)="showDialogCase = true" [disabled]="isLoading"></p-button>
                </div>
                <div *ngIf="hasCases">
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-12 gap-4 md:gap-6 lg:gap-8">
                        <!-- Select Case - 8 kolom -->
                        <div class="col-span-8">
                            <p-select [options]="cases" optionLabel="name" placeholder="Pilih Kasus" [(ngModel)]="selectedCase" (onChange)="showDetails()" class="w-full mb-2" />
                        </div>

                        <!-- Button - 4 kolom -->
                        <div class="col-span-4">
                            <p-button severity="primary" label="Tambah Kasus" icon="pi pi-plus" [raised]="true" variant="outlined" styleClass="w-full" (click)="showDialogCase = true" [disabled]="isLoading"> </p-button>
                        </div>
                    </div>
                    <div *ngIf="selectedCase">
                        <p-button type="button" label="Add Details" class="mr-2" variant="text" [raised]="true" icon="pi pi-plus" (click)="onAddDetails()" [disabled]="isLoading" />
                        <p-button type="button" label="Edit" severity="warn" variant="text" [raised]="true" icon="pi pi-pencil" class="mr-2" (click)="onEdit()" [disabled]="isLoading" />
                        <p-button type="button" label="Delete" severity="danger" variant="text" [raised]="true" icon="pi pi-trash" (click)="onDelete($event)" [disabled]="isLoading" />
                    </div>
                </div>
            </div>

            <!-- Kolom Kanan -->
            <div class="col-span-6" *ngIf="hasCases">
                <h3>Case Details</h3>
                Total Question = {{ formDetails.length }}
            </div>
        </div>

        <hr class="mt-5">
        <div>
            <p-table *ngIf="formDetails.length > 0 && !openAddDetails" [value]="formDetails" [tableStyle]="{ 'min-width': '50rem' }" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>No</th>
                        <th style="width: 50px;">Pertanyaan</th>
                        <th>Gambar</th>
                        <th>Status</th>
                        <th>Jawaban</th>
                        <th>Penjelasan</th>
                        <th style="width: 100px;">Aksi</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-form let-i="rowIndex">
                    <tr>
                        <td>
                            <span class="font-bold">{{ i + 1 }}</span>
                        </td>
                        <td>
                            <div class="max-w-[250px] overflow-hidden text-ellipsis whitespace-nowrap" [innerHTML]="form.description"></div>
                        </td>
                        <td>
                            <p-button type="button" label="Image" class="mr-2" variant="text" [raised]="true" icon="pi pi-image" (click)="showImage(form)" [disabled]="isLoading" />
                        </td>
                        <td>
                            <p-badge [value]="form.is_active == '1' ? 'Active' : 'Inactive'" [severity]="form.is_active == '1' ? 'success' : 'danger'" />
                        </td>
                        <td>
                            <p-accordion [value]="0">
                                <p-accordion-panel value="0">
                                    <p-accordion-header>Show Answers</p-accordion-header>
                                    <p-accordion-content>
                                        <ng-container *ngIf="parseAnswer(form.answer) as parsedAnswer">
                                            <ng-container *ngIf="parsedAnswer.grouped; else singleAnswer">
                                                <div class="overflow-x-auto">
                                                    <div *ngFor="let group of parsedAnswer.data" class="mb-4">
                                                        <div class="font-bold mb-2">{{ group.name }}</div>
                                                        <table class="min-w-full border border-gray-200 rounded-lg shadow-sm bg-white mb-2">
                                                            <thead>
                                                                <tr>
                                                                    <th class="px-4 py-2 border-b font-semibold text-left bg-blue-50 text-blue-700">Field</th>
                                                                    <th class="px-4 py-2 border-b font-semibold text-left bg-blue-50 text-blue-700">Value</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let ans of group.form; let idx = index" [ngClass]="{'bg-blue-50': idx % 2 === 0}">
                                                                    <td class="px-4 py-2 border-b">{{ ans.field }}</td>
                                                                    <td class="px-4 py-2 border-b">{{ ans.value }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-template #singleAnswer>
                                                <div class="overflow-x-auto">
                                                    <table class="min-w-full border border-gray-200 rounded-lg shadow-sm bg-white mb-2">
                                                        <thead>
                                                            <tr>
                                                                <th class="px-4 py-2 border-b font-semibold text-left bg-blue-50 text-blue-700">Field</th>
                                                                <th class="px-4 py-2 border-b font-semibold text-left bg-blue-50 text-blue-700">Value</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let ans of parsedAnswer.data; let idx = index" [ngClass]="{'bg-blue-50': idx % 2 === 0}">
                                                                <td class="px-4 py-2 border-b">{{ ans.field }}</td>
                                                                <td class="px-4 py-2 border-b">{{ ans.value }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </ng-template>
                                        </ng-container>
                                    </p-accordion-content>
                                </p-accordion-panel>
                            </p-accordion>
                        </td>
                        <td>
                            <p-button type="button" label="Explanation" class="mr-2" variant="text" [raised]="true" icon="pi pi-file-pdf" (click)="showExplanation(form)" [disabled]="isLoading" />
                        </td>
                        <td>
                            <p-button type="button" severity="warn" variant="text" [raised]="true" icon="pi pi-pencil" (click)="onEditDetails($event, form)" [disabled]="isLoading" />
                            <p-button type="button" styleClass="mt-2" severity="danger" variant="text" [raised]="true" icon="pi pi-trash" (click)="onDeleteDetails($event, form)" [disabled]="isLoading" />
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <app-add-form-quiz-details
            [cases]="{ id: selectedCase.id, field: form.fields }"
            *ngIf="openAddDetails"
            [editDetail]="editDetail"
            (finishEdit)="onFinishEditDetail()"
        />
    `
})
export class FormQuizCase implements OnInit {
    @Input() form!: {
        id: string;
        name: string;
        fields: string[];
        actived: string;
        created_at: string;
    };

    cases: any[] = [];
    selectedCase: any = null;
    newCaseName: string = '';
    hasCases: boolean = false;
    showDialogCase: boolean = false;
    showDialogEdit: boolean = false;
    editedCaseName: string = '';
    openAddDetails: boolean = false;
    formDetails: any[] = [];
    showDetailImage: boolean = false;
    detailImage: string = '';
    showDetailExplanation: boolean = false;
    detailExplanation: string = '';
    editDetail: any = null; // Tambahkan state untuk edit detail
    showDetailImages: string[] = []; // Tambahkan state array untuk banyak gambar
    isLoading: boolean = false;

    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {}

    async ngOnInit(): Promise<void> {
        this.isLoading = true;
        try {
            const result = await this.userService.getFormCases();
            this.cases = result.data.filter((item: any) => item.form_id === this.form.id);
            this.hasCases = this.cases.length > 0;
        } catch (err) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Gagal memuat data cases.'
            });
        } finally {
            this.isLoading = false;
        }
    }

    onAddDetails() {
        this.openAddDetails = true;
        this.editDetail = null;
        this.messageService.add({
            severity: 'info',
            summary: 'Menambahkan Detail',
            detail: `Untuk case "${this.selectedCase.name}".`
        });
    }

    onEdit() {
        this.editedCaseName = this.selectedCase.name;
        this.showDialogEdit = true;
    }

    // Handler untuk edit detail soal
    onEditDetails(event: Event, detail: any) {
        this.editDetail = detail;
        this.openAddDetails = true;
    }

    // Handler setelah selesai edit detail
    onFinishEditDetail() {
        this.openAddDetails = false;
        this.editDetail = null;
        this.showDetails();
    }

    showDetails() {
        this.isLoading = true;
        this.userService.getFormDetails(this.selectedCase.id).then((res) => {
            this.formDetails = res.data;
        }).finally(() => {
            this.isLoading = false;
        });
    }

    async onDelete(event: Event) {
        if (this.isLoading) return;
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            closable: true,
            closeOnEscape: true,
            rejectButtonProps: {
                label: 'Cancel',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Delete',
                severity: 'danger',
            },
            accept: () => {
                this.handleDelete();
            },
            reject: () => {
                this.messageService.add({
                    severity: 'info',
                    summary: 'Dibatalkan',
                    detail: 'Penghapusan dibatalkan.',
                    life: 3000,
                });
            }
        });
    }

    async submitEditCase() {
        if (this.isLoading) return;
        const trimmedName = this.editedCaseName.trim();
        if (!trimmedName || trimmedName === this.selectedCase.name) {
            this.showDialogEdit = false;
            return;
        }
        this.isLoading = true;
        try {
            const updatedData = {
                id: this.selectedCase.id,
                name: trimmedName,
                form_id: this.form.id
            };

            const res = await this.userService.updateFormCases(updatedData);
            if (res.status === 200) {
                this.selectedCase.name = trimmedName;

                const index = this.cases.findIndex(c => c.id === this.selectedCase.id);
                if (index !== -1) {
                    this.cases[index].name = trimmedName;
                }

                this.ngOnInit();
                this.selectedCase = null;

                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Case berhasil diperbarui.'
                });
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: res.message || 'Gagal memperbarui case.'
                });
            }

            this.showDialogEdit = false;
        } catch (err: any) {
            this.messageService.add({
                severity: 'error',
                summary: 'Kesalahan',
                detail: err.error?.message || 'Terjadi kesalahan saat update case.'
            });
            this.showDialogEdit = false;
        } finally {
            this.isLoading = false;
        }
    }

    private async handleDelete() {
        try {
            const res = await this.userService.deleteFormCases({ id: this.selectedCase.id });
            if (res.status === 200) {
                this.cases = this.cases.filter((c) => c.id !== this.selectedCase.id);
                this.selectedCase = null;
                this.hasCases = this.cases.length > 0;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Case berhasil dihapus.'
                });
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: res.message || 'Gagal menghapus case.'
                });
            }
        } catch (err) {
            this.messageService.add({
                severity: 'error',
                summary: 'Kesalahan',
                detail: 'Terjadi kesalahan saat menghapus case.'
            });
        } finally {
            this.isLoading = false;
        }
    }

    async addCase() {
        if (this.isLoading) return;
        if (!this.newCaseName.trim()) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Peringatan',
                detail: 'Nama case tidak boleh kosong.'
            });
            return;
        }
        this.isLoading = true;
        try {
            const data = {
                name: this.newCaseName.trim(),
                form_id: this.form.id
            };

            const res = await this.userService.addFormCases(data);

            if (res.status === 200) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Case berhasil ditambahkan.'
                });
                this.cases.push({ ...data });
                this.hasCases = true;
                this.newCaseName = '';
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: res.message || 'Gagal menambahkan case.'
                });
            }
        } catch (err : any) {
            this.messageService.add({
                severity: 'error',
                summary: 'Kesalahan',
                detail: err.error.message ||'Terjadi kesalahan saat menambah case.'
            });
        } finally {
            this.isLoading = false;
        }
    }

    parseAnswer(answer: string): any {
        try {
            const parsed = JSON.parse(answer);
            // Jika array dan elemen pertama punya 'name' dan 'form', berarti nested
            if (
                Array.isArray(parsed) &&
                parsed.length > 0 &&
                typeof parsed[0] === 'object' &&
                parsed[0].name &&
                Array.isArray(parsed[0].form)
            ) {
                return { grouped: true, data: parsed };
            }
            // fallback: array of {field, value}
            return { grouped: false, data: parsed };
        } catch {
            return { grouped: false, data: [] };
        }
    }

    async showImage(form: any) {
        if (this.isLoading) return;
        this.isLoading = true;
        const payload = {
            form_detail_id: form.id,
            type: 'image'
        }
        await this.userService.getFormDetailsInfo(payload).then((res: any) => {
            try {
                const value = res.data.value;
                if (value && value.startsWith('[')) {
                    // grouped images
                    const imagesArr = JSON.parse(value);
                    try {
                        this.showDetailImages = imagesArr
                            .filter((img: any) => !!img.image)
                            .map((img: any) => ({
                            name: img.name || 'Gambar tanpa nama',
                            src: img.image
                            }));
                        } catch (e) {
                        console.error('Gagal parse gambar:', e);
                        this.showDetailImages = [];
                    };
                } else {
                    this.showDetailImages = [];
                    this.detailImage = value;
                }
            } catch {
                this.showDetailImages = [];
                this.detailImage = '';
            }
            this.showDetailImage = true;
        }).finally(() => {
            this.isLoading = false;
        });
    }

    async showExplanation(form: any) {
        if (this.isLoading) return;
        this.isLoading = true;
        const payload = {
            form_detail_id: form.id,
            type: 'explanation'
        };
        await this.userService.getFormDetailsInfo(payload).then((res: any) => {
            let explanation = JSON.parse(res.data.value);
            this.detailExplanation = explanation.data;
            this.showDetailExplanation = true;
        }).finally(() => {
            this.isLoading = false;
        });
    }

    onDeleteDetails(event: Event, form: any) {
        if (this.isLoading) return;
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            closable: true,
            closeOnEscape: true,
            rejectButtonProps: {
                label: 'Cancel',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Delete',
                severity: 'danger',
            },
            accept: () => {
                this.handleDeleteDetails(form.id);
            },
            reject: () => {
                this.messageService.add({
                    severity: 'info',
                    summary: 'Dibatalkan',
                    detail: 'Penghapusan dibatalkan.',
                    life: 3000,
                });
            }
        });
    }

    private async handleDeleteDetails(id: number) {
        try {
            const res = await this.userService.deleteFormDetails(id);
            if (res.status === 200) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Detail berhasil dihapus.'
                });
                this.showDetails();
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: res.message || 'Gagal menghapus detail.'
                });
            }
        } catch (err) {
            this.messageService.add({
                severity: 'error',
                summary: 'Kesalahan',
                detail: 'Terjadi kesalahan saat menghapus detail.'
            });
        } finally {
            this.isLoading = false;
        }
    }

}
